import { CameraIcon } from "@heroicons/react/24/outline";
import { IVehicle } from "../../../models/Vehicle";
import ClickToCopy from "../../shared/ClickToCopy";

export default function TableVehicleDetails({ vehicle }: { vehicle: IVehicle | null }) {

  if (!vehicle) {
    return <span className="text-gray-500 italic">No Vehicle Data</span>;
  }

  return (
    <div className="flex gap-x-1 items-center">

      <span className="flex justify-center relative">
        {vehicle?.vehicleImageUrl ? (
          <img
            className="w-32 h-20 object-contain"
            src={vehicle.vehicleImageUrl}
          />
        ) : (
          <CameraIcon className="w-14 mx-10 text-gray-600" />
        )}
      </span>

      <div className="flex flex-col">
        <ClickToCopy title="VRM" text={vehicle.vrm} />
        {vehicle.stockNumber && (
          <ClickToCopy title="Stock Number" text={vehicle.stockNumber} textClassName="text-xs font-semibold" />
        )}
        <span className="Make">{vehicle.combinedMake ?? ""}</span>
        <span title="Model">{vehicle.modelRangeDescription ?? ""}</span>
        <ClickToCopy title="VIN" text={vehicle.combinedVIN} textClassName="text-xs" />
        <ClickToCopy title="Engine Model Code" text={vehicle.engineModelCode} textClassName="text-xs" />
        <span title="Transmission and Fuel Type" className="text-xs">{vehicle.transmission ?? ""} {vehicle.fuelType ?? ""}</span>
      </div>

    </div>
  )
}